import Board from './Board';
import './App.css';

function App() {
  return (
    <Board />
  );
}

export default App;
